// import React, { useState } from 'react';
// import './Navbar.css';
// import { FaBars } from 'react-icons/fa';
// import { Link } from 'react-router-dom';


// export default function Navbar() {
//     const [showCategory, setShowCategory] = useState(false);
//     // const [showHomepage, setShowHomepage] = useState(false);
//     const [showShop, setShowShop] = useState(false);
//     // const [showPages, setShowPages] = useState(false);

//     return (
//         <nav className="navbar">
//             <div className="navbar-left">
//                 <div className="category-dropdown">
//                     <button
//                         className="dropdown-btn"
//                         onClick={() => setShowCategory(!showCategory)}
//                     >
//                         <FaBars className="icon" />SHOP BY CONCERN
//                     </button>
//                     {showCategory && (
//                         <ul className="dropdown-menu">
//                             <li><Link to="/fitness">Physical Fitness</Link></li>
//                             <li><Link to="/mentalhealth">Mental Health</Link></li>
//                         </ul>
//                     )}
//                 </div>

//                 <ul className="nav-links">
//                     <li><a href="/"> Home</a></li>
//                     <li><Link to="/about">About</Link></li>
//                     <li
//                         onMouseEnter={() => setShowShop(true)}
//                         onMouseLeave={() => setShowShop(false)}
//                     >
//                         <a href="#">Shop by Products</a>
//                         {showShop && (
//                             <ul className="dropdown-menu">
//                                 <li><Link to="/shilajit">Shilajit</Link></li>
//                             </ul>
//                         )}
//                     </li>
//                     <li><Link to="/combo"> Best Combos</Link></li>
//                     <li><Link to="/blogSectionblog">Blog</Link></li>
//                     <li><Link to="/faq" className="track-order-link">FAQs</Link></li>
//                     <li><Link to="/contact">Contact</Link></li>
//                 </ul>
//             </div>
//         </nav>
//     );
// }


// 


import React, { useState } from 'react';
import './Navbar.css';
import { FaBars } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Navbar() {
    const [showCategory, setShowCategory] = useState(false);
    const [showShop, setShowShop] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <nav className="navbar">
            <div className="navbar-left">
                {/* Hamburger toggle */}
                <button
                    className="hamburger"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    <FaBars />
                </button>

                {/* Mobile toggle menu */}
                <div className={`nav-links-container ${mobileMenuOpen ? 'active' : ''}`}>
                    {/* SHOP BY CONCERN inside toggle */}
                    <div className="category-dropdown">
                        <button
                            className="dropdown-btn"
                            onClick={() => setShowCategory(!showCategory)}
                        >
                            <FaBars className="icon" />SHOP BY CONCERN
                        </button>
                        {showCategory && (
                            <ul className="dropdown-menu">
                                <li><Link to="/fitness">Physical Fitness</Link></li>
                                <li><Link to="/mentalhealth">Mental Health</Link></li>
                            </ul>
                        )}
                    </div>

                    <ul className="nav-links">
                        <li><a href="/"> Home</a></li>
                        <li><Link to="/about">About</Link></li>
                        <li
                            onMouseEnter={() => setShowShop(true)}
                            onMouseLeave={() => setShowShop(false)}
                        >
                            <a href="#">Shop by Products</a>
                            {showShop && (
                                <ul className="dropdown-menu">
                                    <li><Link to="/shilajit">Shilajit</Link></li>
                                </ul>
                            )}
                        </li>
                        <li><Link to="/combo"> Best Combos</Link></li>
                        <li><Link to="/blogSectionblog">Blog</Link></li>
                        <li><Link to="/faq" className="track-order-link">FAQs</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}






















